import Vue from "vue";
import moment from "moment";

Vue.component("wto-datepicker", {
	props: ["value", "locale", "datetimeFormatter", "todayText", "clearText", "position", "placeholder"],
	data() {
		return {
			pickerPosition: this.position ? this.position : ""
		};
	},
	computed: {
		computedValue: {
			get() {
				if (!this.value) return this.value;
				return moment(this.value).toDate();
			},
			set(value) {
				this.$emit("update:value", value != null ? this.formatDate(value) : null);
			}
		}
	},
	methods: {
		formatDate: function (value) {
			const localDate = moment(value).local();
			return localDate.format("YYYY-MM-DD");
		}
	},
	template: `
	  <b-datepicker v-model="computedValue"
			  :locale="locale"
			  :position="position"
			  :datetime-formatter="datetimeFormatter"
			  :placeholder="placeholder"
			  icon="calendar"
			  trap-focus>
			<div class="columns">
				<div class="column is-offset-one-fifth">							
						<button type="button" class="button is-danger" @click="computedValue = new Date()">
							<span><i class="fas fa-calendar-day"></i> {{ todayText | decodeHTMLEntity }}</span>
						</button>

						<button type="button" class="button is-danger" @click="computedValue = null">
							<span><i class="fas fa-times"></i> {{ clearText | decodeHTMLEntity }}</span>
						</button>
				</div>
			</div>	
	</b-datepicker>
	`
});